import React, { Component } from 'react'
import { getArrowColor } from '@components/LocalMerchant/Decoration/util'
import { inject } from 'mobx-react'

@inject('decorationStore')
export default class extends Component {
  render() {
    const {
      decorationStore: { theme },
      style
    } = this.props
    return (
      <i
        className="iconfont icon-Arrow"
        style={{
          color: getArrowColor(theme),
          flexShrink: 0,
          fontSize: 12,
          ...style
        }}
      />
    )
  }
}
